module.exports = __webpack_public_path__ + "static/media/next-step-icon.6d9eb7a1.svg";